import { render } from "./TalentItem.vue?vue&type=template&id=221666d8"
import script from "./TalentItem.vue?vue&type=script&lang=js"
export * from "./TalentItem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__